<ws-modal-wrapper headerLabel="Filter by Parcel"
                  [disableSave]="!isValid"
                  (save)="updateParcelFilter()"
                  (cancel)="cancel()">
    <div>
        <label class="pull-right">
            <input type="checkbox" [ngModel]="excludeInactive" (ngModelChange)="updateParcels($event)"> Exclude Inactive
        </label>
    </div>
    <div>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</ws-modal-wrapper>
